module.exports = __webpack_public_path__ + "img/sec-14-hyundai.6f112041.svg";